import { z } from 'zod';

export type UpdatePhaseTypePayload = z.infer<typeof updatePhaseTypePayloadSchema>;

export const updatePhaseTypePayloadSchema = z.object({
  color: z.string().optional(),
  description: z.string().optional(),
  name: z.string().optional(),
});
